import scraperApi from "api";
import { IssueSeverity } from "providers/IssuesProvider";
import { AllIssuesLoaderDataType, StatusPageIssuesLoaderDataType } from "v2/hooks/issues/useIssues";


export interface StatuspageIssues {
  mostRecentIssue: any;
  numActiveIssues: number;
  numRecentlyResolvedIssues: number;
}

export interface Issue {
  id: string;
  severity: IssueSeverity;
  title: string;
  happenedAt: Date;
  action: string;
  dismissible: boolean;
  issueStatusUrl?: string;
}

export async function allIssuesLoader({ request }: { request: Request }): Promise<AllIssuesLoaderDataType> {
  return {
    issues: await scraperApi.status.allIssues({ signal: request.signal })
  };
}

export async function statuspageIssuesLoader({ request }: { request: Request }): Promise<StatusPageIssuesLoaderDataType> {
  return {
    issues: await scraperApi.status.issues({ signal: request.signal })
  };
}
